import { LookupItemVm } from './lookupItem';

export class UserShortVm {
    id: number;
    firstName: string;
    lastName: string;
    isSelected: boolean;
}

export class User extends UserShortVm {
    ok: boolean;
    error: boolean;    
    unit: OhiUtins;
    userName: string;
    password: string;
    token: string;        
    email: string;
    phone: string;
    accountNumber: string;
    businessName: string;
    isActive: boolean;
    isLoggedIn: boolean;
    roles: LookupItemVm[];
    services: PaServiceVm[];
    account: UserAccountVm = new UserAccountVm();
    hasRole(id: number):boolean {
        const result = this.roles && this.roles.length && !!this.roles.find((r) => { return r.id === id});
        return result;
    };
    hasOneOfRoles(ids: number[]):boolean {
        const result = this.roles && this.roles.length && !!this.roles.find((r) => { return ids.indexOf(r.id) >= 0 });
        return result;
    }
}

export class PaServiceVm
{
    isUserActive: boolean;
    id: number;
    idp: number;
    name: string;
    title: string;
    description: string;
    meta: PaServiceMetaVm;
    isActive: boolean;    
    createDate: Date;
    isApproved: boolean;
    approvalDate: Date;        
    children: PaServiceVm[];
}

export class PaServiceMetaVm {
    id: number;
    serviceId: number;
    copy: string;
    imageUrl: string;
    routPath: string;
    isActive: boolean;    
    createDate: Date;
}

export class UserAccountVm {   
    id: number;
    userId: number;
    userName: string;
    password: string;
    isActive: boolean;
    createDate: Date;
    isApproved: boolean;
    approvalDate: Date;
    approvedBy: number;
}

export class AuthenticateResponse {
    user: User;
    token: string;
    code: number;
    error: string;
    message: string;
}



export enum OhiUtins {
    Undefined = 0,
    Apex = 1,
    Arizona = 2,
    Langer = 3,
    Pedalign = 4,
    Mdi = 5,
    Safestep = 6,
    Tog = 7,
    OhiAdmin = 8
}